(function () {
    'use strict';

    angular.module("imApp").factory("textileModelCategory4Service", ['$ihttp', function ($ihttp) {
        let service = {
            getTextileModelCategory4: function (parms) {
                return $ihttp.post({
                    method: 2680,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2682,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
